import { useEffect, useState } from 'react';
import { Post } from './blog/container/Post';

export type PostType = {
  _id: string;
  minutes: number;
  urlTitle: string;
  length: number;
  title: string;
  summary: string;
  content?: string;
  cover?: string;
  createdAt: string;
  author?: {
    username: string;
  };
};

const IndexPage = () => {
  const [posts, setPosts] = useState<PostType[]>([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/post`).then((response) => {
      response
        .json()
        .then((posts) => {
          setPosts(posts);
        })
        .catch((error) => {
          console.log('Error fetching data:' + error);
        });
    });
  }, []);
  // console.log(posts);
  return (
    <div className="display-card">
      {posts.length > 0 && posts.map((post) => <Post key={post._id} {...post} />)}
    </div>
  );
};

export default IndexPage;
